import * as React from 'react';
import styles from './CalendarClearFooter.module.css';

export interface CalendarClearFooterProps {
    onClear: () => void;
}

export const CalendarClearFooter: React.FC<CalendarClearFooterProps> = ({onClear}) => (
    <div className={styles.footer}>
        <button type="button" className={styles.clearBtn} onClick={onClear}>
            Очистить
        </button>
    </div>
);
